module.exports = __webpack_public_path__ + "img/trolley.d967df19.png";